function isCursorInViewport(cursor, viewport, zoom) {
  return !(cursor.x < viewport.minX - 12 / zoom || cursor.y < viewport.minY - 16 / zoom || cursor.x > viewport.maxX - 12 / zoom || cursor.y > viewport.maxY - 16 / zoom);
}
export {
  isCursorInViewport
};
//# sourceMappingURL=collaborators.mjs.map
